import {
  CompanyOperationalStatus,
  DeliveryMode,
  InvoiceStatus,
  SetupPackageType,
  SubscriptionTerm,
} from '../../../../../services/exports/Constants';

export default {
  sections: {
    people: 'People',
    financial_metrics: 'Financial metrics',
    onboarding_and_quality: 'Onboarding & Quality',
    subscriptions: 'Current subscriptions',
    payments: 'Payments',
    last_invoices: 'Last invoices',
  },
  fields: {
    google_profile: 'Google profile',
    owner_name: 'Owner name',
    owner_phone_number: 'Owner phone',
    company_phone_number: 'Restaurant phone',
    address: 'Address',
    onboarding_manager: 'Onboarding manager',
    sales_manager: 'Sales manager',
    last_30_days_sales: 'Last 30-days revenue',
    lifetime_sales: 'Total lifetime revenue',
    monthly_sales_other_platforms: 'Delivery Apps Sales',
    delivery_app_sales_at_go_live: 'Delivery app sales at go-live date',
    last_payout: 'Last payout',
    potential_tier: 'Potential Score',
    current_tier: 'IST Score',
    signed_at: 'Closing Date',
    live_from: 'Go Live Date',
    onboarding_quality_score: 'Go Live Quality Score',
    is_google_business_available: 'Google Business available',
    is_smart_pricing_configured: 'Cheaper prices than Lieferando, Wolt, Uber',
    is_flyers_package_sent: 'Promo Flyer sent',
    is_menu_fully_configured: 'All menu items available',
    has_offers_on_competitor_platforms:
      'Does the restaurant has offers running on Wolt, Uber, Lieferando (except free delivery offer)?',
    is_instagram_story_shared: 'Instagram story shared with owner',
    is_order_system_connected_to_website:
      'Foodamigos Website connected OR Restaurant own Website Online Order button added',
    delivery_mode: 'Drivers',
    has_storefront: '{{provider}} website',
    screening_date: 'Screening date',
  },
  setup_fee: {
    title: 'Implementation fee',
    status: {
      [InvoiceStatus.Paid]: 'Paid',
      [InvoiceStatus.Pending]: 'Pending',
      [InvoiceStatus.Processing]: 'Processing',
      [InvoiceStatus.Refunded]: 'Refunded',
      [InvoiceStatus.PartiallyRefunded]: 'Partially refunded',
      [InvoiceStatus.Failed]: 'Failed',
    },
  },
  labels: {
    yes: 'Yes',
    no: 'No',
    month: 'Month',
    recorded_on: 'Recorded on {{date}}',
  },
  delivery_app_sales_correction: {
    title: 'Correct delivery app sales at go-live',
    description:
      "Only fix a typo here. This is the monthly figure onboarding recorded when the restaurant went live, and reporting compares it with sales' figure. The change is logged.",
  },
  operational_status: {
    [CompanyOperationalStatus.Live]: 'Active',
    [CompanyOperationalStatus.Paused]: 'Paused',
    [CompanyOperationalStatus.Suspended]: 'Churned',
  },
  setup_packages: {
    [SetupPackageType.Default]: 'Standard',
    [SetupPackageType.Preferred]: 'Pro',
    [SetupPackageType.Custom]: 'Plus',
  },
  contract_terms: {
    [SubscriptionTerm.Monthly]: 'Monthly',
    [SubscriptionTerm.Annual]: 'Annual',
  },
  delivery_modes: {
    [DeliveryMode.Internal]: 'Own drivers',
    [DeliveryMode.External]: '{{provider}} drivers',
  },
  buttons: {
    view_details: 'View details',
    open: 'Open',
    correct: 'Correct',
    save: 'Save',
    cancel: 'Cancel',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
    delivery_app_sales_corrected: 'Delivery app sales corrected',
    failed_to_correct_delivery_app_sales: 'Could not correct the delivery app sales',
  },
};
